import { createRouter, createWebHashHistory } from 'vue-router'

import QuestionView from '@/views/QuestionView.vue'
import PageNotFound from '@/views/PageNotFound.vue'

import useHelpers from '../utils/helpers'
import { useStageStore } from '../stores/stage';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: QuestionView,
      redirect: "/0"
    },
    {
      path: '/results',
      name: 'results',
      component: QuestionView
    },
    {
      path: '/:id',
      name: 'step',
      component: QuestionView
    },
    {
      path: '/:pathMatch(.*)',
      component: PageNotFound
    },
  ],
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   }
  //   else {
  //     return {
  //       el: '#app',
  //       top: 0,
  //       behavior: 'smooth',
  //     }
  //   }
  // },
})

router.beforeEach((to, from) => {
  
  const { hasAccess } = useHelpers()
  const stageStorage =  useStageStore()
  
  if (stageStorage.isLoading) {
    return; // Access check not yet possible if survey is being initialized
  }

  if (stageStorage.showPasswordForm == true) {
    return; // Access check not required if password form is being shown
  }

  // Check access when requesting transition to valid stages
  if (to?.params?.id) {
    const access = hasAccess(to.params.id)
    if (!access && !stageStorage.previewMode) {
      router.push({ name: 'home' })
      return;
    } 
  }

})

export default router
